import Ajax from '@/common/utils/ajax'

export default {
  async addToBasket(payload) {
    return Ajax.post('/api/services/app/Basket/AddToBasket', payload)
  },
  async getBasket() {
    return Ajax.get('/api/services/app/Basket/GetBasket')
  },
  async remove({ itemId }) {
    return Ajax.delete('/api/services/app/Basket/Remove?itemId=' + itemId)
  },
  async updateQuantity(payload) {
    return Ajax.put('/api/services/app/Basket/UpdateQuantity', payload)
  },
  async setQuantity({productId, quantity}) {
    return Ajax.put('/api/services/app/Basket/SetQuantity', { basketItemId: productId, quantity })
  },
  async setPayment({id}) {
    return Ajax.put('/api/services/app/Basket/SetPayment', { id })
  },
  async setShipping({id}) {
    return Ajax.put('/api/services/app/Basket/SetShipping', { id })
  },
  async trashBasket() {
    return Ajax.post('/api/services/app/Basket/TrashBasket')
  },
  async createOrder(orderData){
    return Ajax.post('/api/services/app/Basket/CreateOrder', orderData)
  }
}

